import { render, staticRenderFns } from "./CalendarEventCard.vue?vue&type=template&id=70d5f605&"
import script from "./CalendarEventCard.vue?vue&type=script&lang=js&"
export * from "./CalendarEventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports